<template>
  <div class="ucard-container">
    <div class="ucard-container-card">
      <div class="card-display">
        <img src="@/assets/imgs/home/2@3x.png" alt="UCard" class="ucard-image" />
      </div>
      <div class="card-description">
        <div class="network-info">
          <span class="network-label">{{ $t('virtualCardOneModule.label') }}</span>
        </div>
        <div class="title">{{ $t('virtualCardOneModule.title') }}</div>
        <div class="features">
          <div class="feature-item" v-for="(feature, index) in $t('virtualCardOneModule.subTitleList')" :key="index">
            <img :src="feature.img" alt="UCard"/>
            <div class="feature-content">
              <div class="feature-title">{{ feature.title }}</div>
              <div class="feature-detail">{{ feature.content }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      features: [
        {
          img: require('@/assets/imgs/home/gaoxiao2.png'),
          title: "高效开卡，极速体验",
          detail: "无限等待，支持秒速开通 Mastercard&Discover虚拟卡，即开即用，开启全球支付之旅"
        },
        {
          img: require('@/assets/imgs/home/jishu2.png'),
          title: "技术领先，安全保障",
          detail: "稳定可靠的技术架构，卡片管理和支付流程保驾护航"
        },
        {
          img: require('@/assets/imgs/home/bizhong2.png'),
          title: "币种多样，交易便捷",
          detail: "提供USD、EUR、GBP等多种卡片，满足特定币种支付需求，有效降低汇损"
        },
        {
          img: require('@/assets/imgs/home/baozhang.png'),
          title: "隐私保障，消费可控",
          detail: "无需信用检查，消费额度可控，为更多人提供便捷、灵活的虚拟卡服务，打破传统金融壁垒。"
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">
.ucard-container {
  padding: 30px 50px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  background-image: url('~@/assets/imgs/home/banner@1x.png');
  background-repeat: round;
  background-size: cover;
  .ucard-container-card {
    display: flex;
    background-color: #fff;
    border-radius: 40px;
    padding: 50px 30px;
    .card-display {
      flex: 1;
      text-align: center;
      align-content: center;
      margin-right: 20px;
      .ucard-image {
        max-width: 100%;
        padding: 10px;
      }
    }
    .card-description {
      flex: 1;
      .network-info {
        .network-label {
          display: inline-block;
          padding: 4px 8px;
          background-color: #2052f3;
          color: #fff;
          border-radius: 16px;
          font-size: 14px;
        }
      }
      .title {
        font-size: 46px;
        font-weight: 400;
        margin: 30px 0;
      }
      .features {
        display: flex;
        flex-wrap: wrap;
        .feature-item {
          align-items: center;
          padding: 0 30px 40px 0;
          width: 50%;
          img {
            width: 30px;
          }
          .feature-content {
            .feature-title {
              font-size: 24px;
              font-weight: bold;
              padding: 10px 0;
            }
            .feature-detail {
              font-size: 18px;
              color: #666;
            }
          }
        }
      }
    }
  }
}
</style>
